import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import {Badge, Button, Col, Row, Spinner, Table} from 'react-bootstrap';
import useApi from '../../../../hooks/use-api';
import { _convertDate } from '../../../../utilities/date-converter';
import { PrepareNullableDataForSend, ReplaceNullsWithEmptyStrings } from '../../../../utilities/rhfdatanormalizationfunctions';
import useMessageStore from '../../../../stores/message-store';
import DeleteButton from '../../../../components/deletebutton';
import * as Yup from 'yup';
import { usePdsAdd, usePdsDefintionsQuery, usePdsDelete, usePdsQuery, usePdsRecordQuery, usePdsUpdate } from '../../../../new/query';
import { useQueryClient } from '@tanstack/react-query';
import { keys } from '../../../../new/keys';
import PdsForm from './pdsform';
import DeleteButtonMutation from '../../../../components/deletebuttonmutation';
import { useOutletContext } from 'react-router-dom';

const PDS = ({}) => {
    const {ApplicationID} = useOutletContext();

    const [editId,setEditId] = useState(null);
    const [states,setStates] = useState([]);
    const [relations,setRelations] = useState([]);
    const [endReasons,setEndReasons] = useState([]);
    const [isLoading,setIsloading] = useState(true); //Default to true
    const [isLoadingEdit,setIsLoadingEdit] = useState(false);
    const [addResetSeq,setAddResetSeq] = useState(0);
    const [initialValues,setInitialValues] =  useState({
        id: null,
        startDate: '',
        endDate: '',
        endReason: '',
        endReasonOther: '',
        hiredOrSupervisedOwnPersonalAssistant: false,
        managedTheirAllowanceBudget: false,
        representativeFirstName: '',
        representativeLastName: '',
        representativeRelation: '',
        representativeAddress: '',
        representativeCity: '',
        representativeState: '',
        representativeZip: '',
        representativePhone: ''
    })
    const editRef = useRef(null);

    const pdsQ = usePdsQuery(ApplicationID);
    const defsQ = usePdsDefintionsQuery();
    const pdsRecordQ = usePdsRecordQuery(ApplicationID,editId,!!editId);
    const queryClient = useQueryClient();

    const queryLoading = pdsQ.isLoading || defsQ.isLoading;
    const isError = pdsQ.isError || defsQ.isError;
    const error = pdsQ.error || defsQ.error;

    const addToast = useMessageStore(state => state.addToast);

    const addSuccesCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "The PDS Entry was succesfully added!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )

        setAddResetSeq((n) => n + 1); //Advance sequence to reset form
    }

    const addErrorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An error occured when adding the PDS Entry.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }

    const updateSuccesCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "The PDS Entry was succesfully updated!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )

        setAddResetSeq((n) => n + 1); //Advance sequence to reset form
    }

    const updateErrorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An error occured when updating the PDS Entry.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }

    

    const pdsAdd = usePdsAdd(ApplicationID,addSuccesCallback,addErrorCallback);
    const pdsUpdate = usePdsUpdate(ApplicationID,updateSuccesCallback,updateErrorCallback);


    const [pdsEntries,setPdsEntries] = useState([]);

    const {getRequest,postRequest,patchRequest} = useApi();

    // const initialValues = {
    //     id: null,
    //     startDate: '',
    //     endDate: '',
    //     endReason: '',
    //     endReasonOther: '',
    //     hiredOrSupervisedOwnPersonalAssistant: false,
    //     managedTheirAllowanceBudget: false,
    //     representativeFirstName: '',
    //     representativeLastName: '',
    //     representativeRelation: '',
    //     representativeAddress: '',
    //     representativeCity: '',
    //     representativeState: '',
    //     representativeZip: '',
    //     representativePhone: ''
    // }


    const _santizieServerData = (data) => {
        const fixedData = ReplaceNullsWithEmptyStrings(data);

        const resetObj = {
            ApplicationId: ApplicationID,
            ...fixedData,
            representativeState: `${fixedData.representativeState}`
        };

        return resetObj;
    }
    const isOverlapping = (newEntry,existingEntry) => {
        const newStart = new Date(newEntry.startDate);
        const newEnd = newEntry.endDate ? new Date(newEntry.endDate) : null;

        const existingStart = new Date(existingEntry.startDate);
        const existingEnd = existingEntry.endDate ? new Date(existingEntry.endDate) : null;

        const newRangeEnd = newEnd || new Date(8640000000000000);
        const existingRangeEnd = existingEnd || new Date(8640000000000000);

        return newStart <= existingRangeEnd && existingStart <= newRangeEnd;
    }
    const _isOverlapping = ({startDate,endDate},entries = [],editingId = null) => {
        const newStart = new Date(startDate);
        const newEnd = endDate ? new Date(endDate) : new Date("9999-12-31");

        return entries.some(({id,startDate: existingStart,endDate: existingEnd}) => {
            if(id === editingId) return false;

            const existingStartDate = new Date(existingStart);
            const existingEndDate = existingEnd ? new Date(existingEnd) : new Date("9999-12-31");

            return newStart <= existingEndDate && existingStartDate <= newEnd;

        });
    }
    

    const validationSchema = Yup.object().shape({
        startDate: Yup.string().required('*Required')
        .test('no-overlap','This date range overlaps with an existing one.',function(value){
                const {endDate} = this.parent;

                if(!endDate) return true;

                return !_isOverlapping({startDate: value,endDate},pdsEntries,editId);
            }),
        endDate: Yup.string().nullable()
            .test('endRequiredWhenReason','End Date is required when supplying and End Reason',function(value) {
                const {endReason} = this.parent;

                if(endReason === '') return true;

                return value !== '';
            })
            .test('no-overlap','This date range overlaps with an existing one.',function(value){
                const {startDate} = this.parent;

                if(!startDate) return true;

                return !_isOverlapping({startDate,endDate: value},pdsEntries,editId);
            })
            .test('valid-end','End date must be after or on start date',function(value){
                const {startDate} = this.parent;

                if(!value || !startDate) return true;

                return new Date(value) >= new Date(startDate)
        }),
        endReason: Yup.string().when('endDate',{
            is: (val) => val !== null && val !== '',
            then: (schema) => schema.required("End Reason is required when supplying an End Date."),
            otherwise: (schema) => schema.notRequired()
        }),
        endReasonOther: Yup.string().when('endReason',{
            is: (val) => defsQ.data.endreasons.find(item => item.id === val)?.hasfollowup,
            then: (schema) => schema.required("*Required"),
            otherwise: (schema) => schema.notRequired()
        })
    });

    // const {handleSubmit,register,control,watch,resetField,reset,formState: {isDirty,isSubmitting,errors}} = useForm({defaultValues: initialValues,resolver: yupResolver(validationSchema)});

    // const getAll = async() => {
    //     setIsloading(true);

    //     const[typesData,pdsData] = await Promise.all([
    //         getRequest('PDSDefinitions',{timestamp: Date.now()}),
    //         getRequest('PDSGetAll',{ApplicationID: ApplicationID,timestamp: Date.now()})
    //     ]);

    //     const [extractedTypeData,typeStatus] = typesData;
    //     const [extractedPDSData,pdsStatus] = pdsData;

    //     if(typeStatus === 200 && pdsStatus === 200){
    //         setStates(extractedTypeData.states);
    //         setRelations(extractedTypeData.relationships);
    //         setEndReasons(extractedTypeData.endreasons);
    //         setPdsEntries(extractedPDSData);
    //     }

    //     setIsloading(false);
    // }

    const _handleEdit = async(pdsId) => {
        //Smooth scroll to top editor panel
        if(editRef.current){
            editRef.current.scrollIntoView({behavior: 'smooth'});
        }

        setEditId(pdsId);

        // setIsLoadingEdit(true);

        // const [data,status] = await getRequest('PDSEntry',{PDSId: pdsId,ApplicationId: ApplicationID,timestamp: Date.now()});

        // if(status === 200){
        //     const fixedData = ReplaceNullsWithEmptyStrings(data);

        //     const resetObj = {
        //         ApplicationId: ApplicationID,
        //         ...fixedData,
        //         representativeState: `${fixedData.representativeState}`
        //     };

        //     reset(resetObj);

        //     setEditId(pdsId);
        // }

        // setIsLoadingEdit(false);
    }

    // useEffect(() => {
    //     if(pdsRecordQ?.data){
    //         const fixedData = ReplaceNullsWithEmptyStrings(pdsRecordQ.data);

    //         const resetObj = {
    //             ApplicationId: ApplicationID,
    //             ...fixedData,
    //             representativeState: `${fixedData.representativeState}`
    //         };

    //         reset(resetObj);
    //     }
    // },[pdsRecordQ.data,ApplicationID])

    // const _editDeselect = () => {
    //     setEditId(null);
    //     reset({
    //         ApplicationId: ApplicationID,
    //         ...initialValues
    //     });
    // }

    // const _refreshTable = async() => {
    //     const [data,status] = await getRequest('PDSGetAll',{ApplicationID: ApplicationID,timestamp: Date.now()});

    //     if(status === 200){
    //         setPdsEntries(data);
    //     }
    // }

    const _submit = (values) => {
        const sendObject = PrepareNullableDataForSend(values);

        if(sendObject.endReasonOther){
            if(!sendObject.endReason){
                //null End Reason need to remove endReasonOther
                sendObject.endReasonOther = null;
            }
            else{
                if(!defsQ.data.endreasons.find(item => item.id === sendObject.endReason).hasfollowup){
                    //null End Reason when does not have followup
                    sendObject.endReasonOther = null;
                }
            }
        }

        if(editId){
            pdsUpdate.mutate({ApplicationId: ApplicationID,...sendObject});
        }
        else{
            pdsAdd.mutate({ApplicationId: ApplicationID,...sendObject});
        }
    }

    const _handleSubmit = async(values) => {
        const sendObject = PrepareNullableDataForSend(values);

        if(sendObject.endReasonOther){
            if(!sendObject.endReason){
                //null End Reason need to remove endReasonOther
                sendObject.endReasonOther = null;
            }
            else{
                if(!defsQ.data.endreasons.find(item => item.id === sendObject.endReason).hasfollowup){
                    //null End Reason when does not have followup
                    sendObject.endReasonOther = null;
                }
            }
        }

        // const isOver = _isOverlapping({startDate: sendObject.startDate,endDate: sendObject.endDate},pdsEntries,sendObject.id);
        // console.log(isOver);

        if(editId){
            const [data,status] = await patchRequest('UpdatePDS',sendObject);

            if(status === 200){
                const fixedData = ReplaceNullsWithEmptyStrings(data);

                const resetObj = {
                    ApplicationId: ApplicationID,
                    ...fixedData,
                    representativeState: `${fixedData.representativeState}`
                };

                addToast(
                    {
                        id: Math.random(),
                        body: "The PDS Entry was succesfully updated!",
                        autoHide: true,
                        errorFlag: false,
                        timestamp: Date.now() - 1000
                    }
                )

                // reset(resetObj);

                queryClient.invalidateQueries({queryKey: keys.pds.list(ApplicationID)});
            }
            else{
                addToast(
                    {
                        id: Math.random(),
                        body: "An error occured when updating the PDS Entry.",
                        autoHide: true,
                        errorFlag: true,
                        timestamp: Date.now() - 1000
                    }
                )
            }
        }
        else{
            const [data,status] = await postRequest('AddPDS',sendObject);

            if(status === 201){
                addToast(
                    {
                        id: Math.random(),
                        body: "The PDS Entry was succesfully added!",
                        autoHide: true,
                        errorFlag: false,
                        timestamp: Date.now() - 1000
                    }
                )

                // reset({
                //     ApplicationId: ApplicationID,
                //     ...initialValues
                // });

                queryClient.invalidateQueries({queryKey: keys.pds.list(ApplicationID)});
            }
            else{
                addToast(
                    {
                        id: Math.random(),
                        body: "An error occured when adding the PDS Entry.",
                        autoHide: true,
                        errorFlag: true,
                        timestamp: Date.now() - 1000
                    }
                )
            }
        }
    }

    const _deleteSuccessCallback = () => {


        addToast(
                    {
                        id: Math.random(),
                        body: "The PDS Entry was deleted.",
                        autoHide: true,
                        errorFlag: false,
                        timestamp: Date.now() - 1000
                    }
                )
    }

    const _deleteErrorCallback = () => {
        addToast(
                    {
                        id: Math.random(),
                        body: "The PDS Entry was unable to be deleted.",
                        autoHide: true,
                        errorFlag: true,
                        timestamp: Date.now() - 1000
                    }
                )
    }

    const _stateLookup = (stateId) => {
        return defsQ.data.states.find(item => item.id === parseInt(stateId))?.name;
    }

    const _endReasonLookup = (erId) => {
        return defsQ.data.endreasons.find(item => item.id === erId)?.name;
    }

    const _relationLookup = (relId) => {
        return defsQ.data.relationships.find(item => item.id === relId)?.name;
    }


    // useEffect(() => {
    //     getAll();
    // },[]) 

    // const endReasonval = watch('endReason');

    // const selectedEndReason = defsQ.data.endreasons.find(item => item.id === endReasonval);

    // useEffect(() => {
    //     if(!editId){
    //         //Only reset in add mode
    //         if(selectedEndReason){
    //             if(selectedEndReason.hasfollowup){
    //                 resetField('endReasonOther',{defaultValue: ''});
    //             }
    //         }
    //         else{
    //             resetField('endReasonOther',{defaultValue: ''});
    //         }
    //     }
    // },[selectedEndReason,editId,resetField])

    // const requiredOtherEndReason = endReasonval !== ''
    // ?
    //     defsQ.data.endreasons.find(item => item.id === endReasonval)?.hasfollowup
    // :
    //     false

    if(queryLoading){
        return(
            <div>loading...</div>
        )
    }

    return(
        <Row>
            <Col xs={12}>
                <div className='clientCard'>
                    <div className='clientCardInner'>
                        <h4 className="text-center">Participant Directed Services (PDS)</h4>
                        <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}} ref={editRef}>
                            {/* <form onSubmit={handleSubmit(_handleSubmit)}>
                                <input type='hidden' {...register('id')} />
                                <input type='hidden' {...register('ApplicationId')} />
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <Row>
                                            <Col xs={12}>
                                                <label htmlFor='participationstartdate'>Participation Start Date</label>
                                                <input type='date' id='participationstartdate' style={{width: '100%',height: '30px'}} {...register('startDate')} />
                                                {
                                                    errors.startDate
                                                    &&
                                                    <FormInputValidationMessage error={errors?.startDate} />
                                                }
                                            </Col>
                                            <Col xs={12}>
                                                <label htmlFor='participationenddate'>Participation End Date</label>
                                                <input type='date' id='participationenddate' style={{width: '100%',height: '30px'}} {...register('endDate')}/>
                                                <FormInputValidationMessage error={errors?.endDate} />
                                            </Col>
                                            <Col xs={12}>
                                                <label htmlFor='endreason'>End Reason</label>
                                                <select id='endreason' style={{width: '100%',height: '30px'}} {...register('endReason')}>
                                                    <option value=''>--Select End Reason--</option>
                                                    {
                                                        defsQ.data.endreasons.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.name}</option>
                                                        ))
                                                    }
                                                </select>
                                                <FormInputValidationMessage error={errors?.endReason} />
                                            </Col>
                                            {
                                                requiredOtherEndReason &&
                                                <Col xs={12}>
                                                    <label htmlFor='endreasonother'>End Reason Other</label>
                                                    <input type='text' id='endreasonother' style={{width: '100%'}} {...register('endReasonOther')}/>
                                                    <FormInputValidationMessage error={errors?.endReasonOther} />
                                                </Col>
                                            }
                                            <Col xs={12}>
                                                <label>
                                                    <input type='checkbox' {...register('hiredOrSupervisedOwnPersonalAssistant')}/>
                                                    Hired or Supevised Own Personal Assistant
                                                </label>
                                            </Col>
                                            <Col xs={12}>
                                                <label>
                                                    <input type='checkbox' {...register('managedTheirAllowanceBudget')} />
                                                    Managed Their Allowance Budget
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12} md={6} lg={8}>
                                        <Row>
                                            <Col xs={12} md={6}>
                                                <label htmlFor='repfirstname'>Representative First Name</label>
                                                <input type='text' id='repfirstname' style={{width: '100%'}} {...register('representativeFirstName')} />
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <label htmlFor='replastname'>Representative Last Name</label>
                                                <input type='text' id='replastname' style={{width: '100%'}} {...register('representativeLastName')} />
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <label htmlFor='reprelation'>Representative Relation</label>
                                                <select id='reprelation' style={{width: '100%',height: '30px'}} {...register('representativeRelation')}>
                                                    <option value=''>--Select Relation--</option>
                                                    {
                                                        defsQ.data.relationships.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <label htmlFor='repaddress'>Representative Address</label>
                                                <input type='text' id='repaddress' style={{width: '100%'}} {...register('representativeAddress')}/>
                                            </Col>
                                            <Col xs={12} md={4}>
                                                <label htmlFor='repcity'>Representative City</label>
                                                <input type='text' id='repcity' style={{width: '100%'}} {...register('representativeCity')}  />
                                            </Col>
                                            <Col xs={12} md={4}>
                                                <label htmlFor='repstate'>Representative State</label>
                                                <select id='repstate' style={{width: '100%',height: '30px'}} {...register('representativeState')} >
                                                    <option value=''>--Select a State--</option>
                                                    {
                                                        defsQ.data.states.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </Col>
                                            <Col xs={12} md={4}>
                                                <label htmlFor='repzip'>Representative Zip</label>
                                                <input type='text' id='repzip' style={{width: '100%'}} {...register('representativeZip')} />
                                            </Col>
                                            <Col xs={12} md={4}>
                                                <label htmlFor='repphone'>Representative Phone #</label>
                                                <input type='text' id='repphone' style={{width: '100%'}} {...register('representativePhone')}  />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12} className='mt-4'>
                                        <Row>
                                            <Col xs={12}>
                                            {
                                                editId
                                                ?
                                                    <div className='d-flex justify-content-between' key='a'>
                                                        <Button type='button' variant='danger' onClick={_editDeselect}>
                                                            Cancel
                                                        </Button>
                                                        <Button type='submit' variant='primary' disabled={!isDirty || isSubmitting}>
                                                            {
                                                                isSubmitting
                                                                ?
                                                                    <Spinner animation="border" size="sm" />
                                                                :
                                                                    <>Save Changes</>
                                                            }
                                                        </Button>
                                                    </div>
                                                :
                                                    <div className='d-flex justify-content-end' key='b'>
                                                        <Button type='submit' variant='success' disabled={!isDirty || isSubmitting}>
                                                            {
                                                                isSubmitting
                                                                ?
                                                                    <Spinner animation="border" size="sm" />
                                                                :
                                                                    <>Add</>
                                                            }
                                                        </Button>
                                                    </div>
                                            }
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </form> */}
                            {
                                editId
                                ?
                                    (
                                        <>
                                            {pdsRecordQ.isLoading ? (
                                                <div>loading...</div>
                                            ) : pdsRecordQ.isError ?(
                                                <div>error</div>
                                            ) :
                                                <PdsForm
                                                    TargetId={editId}
                                                    initialValues={pdsRecordQ.data}
                                                    onSubmit={(vals) => _submit(vals) }
                                                    isSubmitting={pdsUpdate.isPending}
                                                    endReasons={defsQ.data.endreasons}
                                                    states={defsQ.data.states}
                                                    relationships={defsQ.data.relationships}
                                                    pdsEntries={pdsQ.data}
                                                    deselect={() => setEditId(null)}

                                                />
                                            }
                                            
                                        </>
                                    )
                                :
                                    (
                                        <PdsForm
                                            key={`add-${addResetSeq}`}
                                            TargetId={editId}
                                            initialValues={initialValues}
                                            onSubmit={(vals) => _submit(vals) }
                                            isSubmitting={pdsAdd.isPending}
                                            endReasons={defsQ.data.endreasons}
                                            states={defsQ.data.states}
                                            relationships={defsQ.data.relationships}
                                            pdsEntries={pdsQ.data}
                                            deselect={() => setEditId(null)}
                                        />
                                    )
                            }
                        </div>
                        <Row className='mt-4'>
                            <Col xs={12}>
                                <h5 className='text-center fw-bold'>PDS Entries</h5>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>End Reason</th>
                                            <th>Personal Assistant?</th>
                                            <th>Allowance Budget?</th>
                                            <th>Representative Information</th>
                                            <th>Last Modified By</th>
                                            <th>Last Modified Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead> 
                                    <tbody>
                                        {
                                            pdsQ.data.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.startDate}</td>
                                                    <td>{item.endDate}</td>
                                                    <td>
                                                        {_endReasonLookup(item.endReason)} <br /> <br />
                                                        {item.endReasonOther}
                                                    </td>
                                                    <td>{item.hiredOrSupervisedOwnPersonalAssistant ? <>Yes</> : <>No</>}</td>
                                                    <td>{item.managedTheirAllowanceBudget ? <>Yes</> : <>No</>}</td>
                                                    <td>
                                                        First Name: {item.representativeFirstName} <br />
                                                        Last Name: {item.representativeLastName}<br/>
                                                        Relation: {_relationLookup(item.representativeRelation)}<br />
                                                        Address: {item.representativeAddress} <br/>
                                                        City: {item.representativeCity} <br />
                                                        State: {_stateLookup(item.representativeState)} <br />
                                                        Zip: {item.representativeZip} <br/>
                                                        Phone #: {item.representativePhone}
                                                    </td>
                                                    <td>{item.lastModifiedByUser}</td>
                                                    <td>{_convertDate(item.lastModifiedDate)}</td>
                                                    <td>
                                                        {
                                                            editId === item.id
                                                            ?
                                                                editId === null
                                                                ?
                                                                    <Badge pill bg="info">Inserting</Badge>
                                                                :
                                                                    <Badge pill bg="info">Editing</Badge>
                                                            :
                                                                <div className='d-flex'>
                                                                    <Button type='button' size='sm' variant='secondary' className='me-1' title="Edit PDS Entry" aria-label="Edit PDS Entry" onClick={() => _handleEdit(item.id)} disabled={item.isDeleting}>
                                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                                    </Button>
                                                                    <DeleteButtonMutation
                                                                        deleteObject={{ApplicationId: ApplicationID,PDSId: item.id}}
                                                                        confirmText='Delete?'
                                                                        useDeleteHook={usePdsDelete}
                                                                        hookArgs={[ApplicationID,_deleteSuccessCallback,_deleteErrorCallback]}
                                                                        successCallback={_deleteSuccessCallback}
                                                                        errorCallback={_deleteErrorCallback}
                                                                    />
                                                                    {/* <DeleteButton
                                                                        deleteObject={{ApplicationId: ApplicationID,PDSId: item.id}}
                                                                        endpoint="DeletePDS"
                                                                        successCallback={_deleteSuccessCallback}
                                                                        errorCallback={_deleteErrorCallback}
                                                                        confirmText='Delete?'
                                                                    /> */}
                                                                </div>
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default PDS;
